// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAsyrupusdc } from "../../../icons/full/build/icon-asyrupusdc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AsyrupusdcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAsyrupusdc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AsyrupusdcIcon.displayName = 'AsyrupusdcIcon';
}

export default AsyrupusdcIcon;